export const environment = {
  production: true,
  BASE_API: 'https://admin-backend.sandos.com',
  BASE_IMAGE_API: 'https://www.sandos4u.com',
  ROLE: '',
  VOUCHER_PDF_LINK: 'https://admin.sandos.com/assets/pdfs/',
  m4u_callcenter_emailId: 'callcenter.eur@sandos.com',
  sandos_callcenter_emailId: 'callcenter.mx@sandos.com',
  REPORTS_HOST: 'https://admin.sandos.com/assets/reports'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts